module.exports = __webpack_public_path__ + "static/media/responsive-design2.14c65309.png";